export const areDimensionsEqual = (dimensionArray1: string[], dimensionArray2: string[]) => {
  const arr1 = [...(dimensionArray1 || [])].sort();
  const arr2 = [...(dimensionArray2 || [])].sort();
  return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
};
